module.exports = __webpack_public_path__ + "static/media/SF_bm_sentrert_logo_vestfold_telemark_neg.6d58dd44.pdf";